/**
 * 生成对账单
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ReconciliationModal.module.scss';
import http from '@/assets/api/http';
import { Modal, message, Form, Input, DatePicker, Select } from 'antd';


const layout = {
    labelCol: {
        span: 4
    }
};

const InfoModal = (props) => {

    const [form] = Form.useForm();
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [paymentUnitList, setPaymentUnitList] = useState([]);

    const [dates, setDates] = useState([]);
    const disabledDate = current => {
        if (!dates || dates.length === 0) {
            return false;
        }
        const tooLate = dates[0] && current.diff(dates[0], 'days') >= 70;
        const tooEarly = dates[1] && dates[1].diff(current, 'days') >= 70;
        return tooEarly || tooLate;
    };

    const onOpenChange = open => {
        open && setDates([])
    };

    const _handleOk = () => {
        form.validateFields().then(({ rangeTimes, ...fields }) => {
            setConfirmLoading(true);
            http('/?cmd=com.xqxc.api.pig.mis.reconciliation.ReconciliationApiMisService.generateReconciliation', {
                ...fields,
                targetName: paymentUnitList.find((v) => v.value === fields.targetId).label,
                startDate: rangeTimes[0].format('YYYY-MM-DD'),
                endDate: rangeTimes[1].format('YYYY-MM-DD'),
                targetType: 'ENTERPRISE',
                type: 'ENTERPRISE',
            }).then(() => {
                message.success('操作成功');
                setConfirmLoading(false);
                props.closeMode && props.closeMode(true);
            }).catch((e = {}) => {
                message.error(e.errDesc);
                setConfirmLoading(false);
            });
        });
    }

    const _handleCancel = () => {
        props.closeMode && props.closeMode();
    }

    useEffect(() => {
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.EnterpriseAccountMisService.listAllEnterpriseName', {}).then(res => {
            if (res.errCode === 0) {
                let arr = (res.result || []).map(v => ({ value: v.userId, label: v.epName }));
                setPaymentUnitList(arr);
            }
        })
    }, []);

    return (
        <Modal
            width={520}
            centered
            title={props.title}
            visible={props.visible}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >
            <Form {...layout} className={styles.container} form={form} labelAlign='right'>
                <Form.Item label="企业名称" name="targetId" rules={[{ required: true, message: '请选择企业名称' }]}>
                    <Select
                        showSearch
                        placeholder='请输入'
                        options={paymentUnitList}
                        filterOption={(input, option) => (option.label || '').toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    />
                </Form.Item>
                <Form.Item label="截止日期" name="rangeTimes" rules={[{ required: true, message: '请选择时间范围' }]}>
                    <DatePicker.RangePicker
                        style={{ width: '100%' }}
                        placeholder={['开始', '结束']}
                        showTime={false}
                        disabledDate={disabledDate}
                        onCalendarChange={val => setDates(val)}
                        onOpenChange={onOpenChange}
                    />
                </Form.Item>
                <Form.Item label="备注" name="remark">
                    <Input.TextArea placeholder='请输入' />
                </Form.Item>
            </Form>
            <div style={{ color: '#FF0000' }}>提示：按起止日期生成对账单，最大间隔天数为70天</div>
        </Modal>
    );

}

InfoModal.propTypes = {
    positionList: PropTypes.array,
    data: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object
    ]), // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
    type: PropTypes.string,
    curTabID: PropTypes.string,
};

export default InfoModal;